/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListPersonsRequest
 */
export interface ListPersonsRequest {
    /**
     * 
     * @type {number}
     * @memberof ListPersonsRequest
     */
    cursor?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPersonsRequest
     */
    limit?: number;
}

export function ListPersonsRequestFromJSON(json: any): ListPersonsRequest {
    return ListPersonsRequestFromJSONTyped(json, false);
}

export function ListPersonsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPersonsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function ListPersonsRequestToJSON(value?: ListPersonsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cursor': value.cursor,
        'limit': value.limit,
    };
}


